import { apiCall } from '../api/ServerApi';
import { API_URL_PATHS } from '../consts/ApiUrlPaths';
import { IUser } from '../interfaces/User';

const { USER_URL_PATH } = API_URL_PATHS;

export async function getUserMetadata(): Promise<IUser> {
	return apiCall('GET', USER_URL_PATH);
}
